import { v4 as uuid } from 'uuid';
import UtilisateurService from '../../components/dashboard/services/UtilisateurService';

const accueilMenu = [
	{
		id: uuid(),
		title: 'Accueil',
		icon: 'house',
		link: '/'
	}
];

const adminMenu = [
	{
		id: uuid(),
		title: 'Administration',
		grouptitle: true
	},

	{
		id: uuid(),
		title: 'Utilisateurs',
		icon: 'users-gear',
		link: '/administration/utilisateurs'
	}
];

const educationMenu = [
	{
		id: uuid(),
		title: 'Education',
		grouptitle: true
	},

	{
		id: uuid(),
		title: 'Elèves',
		icon: 'users',
		link: '/education/eleves'
	},

	{
		id: uuid(),
		title: 'Parents',
		icon: 'user-group',
		link: '/education/parents'
	}
];

const personnelMenu = [
	{
		id: uuid(),
		title: 'Personnel',
		grouptitle: true
	},

	{
		id: uuid(),
		title: 'Personnel',
		icon: 'user-check',
		link: '/administration/personnel'
	},

	{
		id: uuid(),
		title: 'Contrats',
		icon: 'file-contract',
		link: '/administration/personnel/contrats'
	},

	{
		id: uuid(),
		title: 'Salaires',
		icon: 'file-invoice-dollar',
		link: '/administration/personnel/salaires'
	}
];

const locauxMenu = [
	{
		id: uuid(),
		title: 'Locaux',
		grouptitle: true
	},

	{
		id: uuid(),
		title: 'Classes',
		icon: 'chalkboard-user',
		link: '/locaux/classes'
	},

	{
		id: uuid(),
		title: 'Autres',
		icon: 'school',
		link: '/locaux/autres'
	}
];

const pedagogieMenu = [
	{
		id: uuid(),
		title: 'Pédagogie',
		grouptitle: true
	},

	{
		id: uuid(),
		title: 'Matières',
		icon: 'book',
		link: '/pedagogie/matieres'
	},

	{
		id: uuid(),
		title: 'Compétences',
		icon: 'list-check',
		link: '/pedagogie/competences'
	},

	{
		id: uuid(),
		title: 'Notes',
		icon: 'file-invoice',
		link: '/pedagogie/notes'
	},

	{
		id: uuid(),
		title: 'Bibliothèque',
		icon: 'book-bookmark',
		children: [
			{
				id: uuid(),
				name: 'Livres',
				link: '/services/bibliotheque/catalogue'
			},
			{
				id: uuid(),
				name: 'Emprunts',
				link: '/services/bibliotheque/emprunts'
			}
		]
	}
];

const financesMenu = [
	{
		id: uuid(),
		title: 'Finances',
		grouptitle: true
	},

	{
		id: uuid(),
		title: 'Frais de scolarité',
		icon: 'sack-dollar',
		children: [
			{
				id: uuid(),
				name: 'Enregistrement frais',
				link: '/finances/scolarite'
			},
			{
				id: uuid(),
				name: 'Suivi paiement',
				link: '/finances/scolarite/suivipaiement'
			}
		]
	},

	{
		id: uuid(),
		title: 'Tenues',
		icon: 'shirt',
		link: '/finances/tenues'
	},

	{
		id: uuid(),
		title: 'Bilan',
		icon: 'scale-balanced',
		link: '/finances/bilan'
	},

	{
		id: uuid(),
		title: 'Budget',
		icon: 'landmark',
		link: '/finances/budget'
	}
];

const servicesMenu = [
	{
		id: uuid(),
		title: 'Services',
		grouptitle: true
	},

	{
		id: uuid(),
		title: 'Maintenance',
		icon: 'screwdriver-wrench',
		link: '/services/maintenance'
	},

	{
		id: uuid(),
		title: 'Assets',
		icon: 'dolly',
		children: [
			{
				id: uuid(),
				name: 'Type de local',
				link: '/assets/typelocal'
			},
			{
				id: uuid(),
				name: 'Matériels',
				link: '/assets/materiels'
			}
		]
	}
];

const archivesMenu = [
	{
		id: uuid(),
		title: 'Archives',
		grouptitle: true
	},

	{
		id: uuid(),
		title: 'Anciens élèves',
		icon: 'user-graduate',
		link: '/archives/eleves'
	},

	{
		id: uuid(),
		title: 'Ancien personnel',
		icon: 'user-tag',
		link: '/archives/personnel'
	}
];

const allMenus = [
	...accueilMenu,
	...adminMenu,
	...educationMenu,
	...personnelMenu,
	...locauxMenu,
	...pedagogieMenu,
	...financesMenu,
	...servicesMenu,
	...archivesMenu
];

const accessControl = {
	Fondatrice: allMenus,
	default: allMenus,
	Directrice: [
		...accueilMenu,
		...educationMenu,
		...locauxMenu,
		...pedagogieMenu
	],
	Comptable: [
		...accueilMenu,
		...personnelMenu,
		...financesMenu,
		...servicesMenu,
		...archivesMenu
	],
	Econome: [
		...accueilMenu,
		...personnelMenu,
		...financesMenu,
		...servicesMenu,
		...archivesMenu
	],
	Enseignant: [...accueilMenu, ...pedagogieMenu],
	Informaticien: [...accueilMenu, ...pedagogieMenu],
	Secrétaire: [
		...accueilMenu,
		...educationMenu,
		...locauxMenu,
		...pedagogieMenu.filter((menu) =>
			['Pédagogie', 'Notes'].includes(menu.title)
		)
	]
};

const getDashboardMenu = () => {
	const userDetails = UtilisateurService.getUserDetailsFromLocalStorage();
	const userRole = userDetails.role;
	return accessControl[userRole] || accessControl.default;
};

export const DashboardMenu = getDashboardMenu();

export default DashboardMenu;
